module.exports = __webpack_public_path__ + "static/media/ice04.0e8cc471.webp";